import React, { forwardRef } from 'react';
import { FormikProps } from 'formik';
import { Box } from '@material-ui/core';
import { UnitType } from '../../generated/graphql';
import { Typography } from '../Typography';
import { CounterFieldWithSelect } from '../../components/forms/fields';
import { InputCounterFieldProps, SelectCounterFieldProps } from '../../components/forms/fields/CounterFieldWithSelect';
import { UnitTypeOptions, setUnitTypes } from '../../layout/unitTypes';
import { WarehouseCardCounterWrapper } from './style';

interface WarehouseCardCounterProps<T> {
    inputProps: Omit<InputCounterFieldProps, 'isTextHightlighted'>;
    selectProps: Omit<SelectCounterFieldProps, 'options'>;
    storageUnit: UnitType;
    alternativeUnit?: UnitType;
    formikProps: FormikProps<T>;
    label: string;
    handleChange?: (e: React.ChangeEvent<any>) => void;
    categoryName: string;
    isFilled?: boolean;
    isDanger?: boolean;
}

const WarehouseCardCounter = <T,>(
    {
        inputProps,
        selectProps,
        storageUnit,
        alternativeUnit,
        formikProps,
        label,
        handleChange,
        categoryName,
        isFilled,
        isDanger,
    }: WarehouseCardCounterProps<T>,
    ref: React.Ref<HTMLDivElement | null>
) => {
    const options: Array<UnitTypeOptions> = [];
    setUnitTypes(options, storageUnit, alternativeUnit);

    const colorVariant = isFilled ? 'success' : undefined;

    return (
        <WarehouseCardCounterWrapper ref={ref as any} isFilled={isFilled} isDanger={isDanger}>
            <Box maxWidth="40%" display="flex" flexDirection="column">
                <Typography colorVariant={colorVariant} fontWeight="medium">{label}</Typography>
                <Typography colorVariant={colorVariant} variant="body2">{categoryName}</Typography>
            </Box>
            <Box maxWidth="60%" minWidth="200px">
                <CounterFieldWithSelect
                    handleChange={handleChange}
                    inputProps={{ ...inputProps, isDanger, isTextHighlighted: isFilled }}
                    selectProps={{
                    ...selectProps,
                    options,
                }}
                    maxDecimals={3}
                    minLimit={0}
                    formikProps={formikProps}
                />
            </Box>
        </WarehouseCardCounterWrapper>
    );
};

export default forwardRef(WarehouseCardCounter) as <T>(
    props: WarehouseCardCounterProps<T> & { ref?: React.Ref<HTMLDivElement | null> }
) => ReturnType<typeof WarehouseCardCounter>;